import { createContext } from "react";
//app.js context
export const UserInfo = createContext(null);
export const NotificationInfo = createContext(null);
export const PermissionInfo = createContext(null);
export const TabContext = createContext(null);
export const SubscriptionInfo = createContext(null);

export const CustomerOrderInfo = createContext(null);
